import { ClearanceOutput } from 'enums';
import { messages } from 'i18n';

const { clearanceOutputLabels } = messages.submissionQueuePage;

export const clearanceOutputConfig: Record<ClearanceOutput, { label: string; color: string }> = {
  [ClearanceOutput.Cleared]: { label: clearanceOutputLabels.cleared, color: 'green.100' },
  [ClearanceOutput.NotAppointed]: { label: clearanceOutputLabels.notAppointed, color: 'error.light' },
  [ClearanceOutput.Duplicate]: { label: clearanceOutputLabels.duplicate, color: 'warning.light' },
  [ClearanceOutput.Error]: { label: clearanceOutputLabels.error, color: 'error.light' },
};

export const getClearanceOutputLabel = (value: ClearanceOutput) => clearanceOutputConfig[value].label;
